import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { form, TFormCodec } from "../../../shared/src/codecs/types/form";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { TUuidObjectCodec, UuidObject } from "../Id";

export const UuidForm: TFormCodec<TUuidObjectCodec, TEmptyObjectCodec> = form(UuidObject, EmptyObject);
export type TUuidFormCodec = typeof UuidForm;
export type TUuidForm = TTypeOfCodec<TUuidFormCodec>;
